import { Button } from "../../Atoms/Button";
import { Input } from "../../Atoms/Inputs/Input";
import { Title } from "../../Atoms/Title";
import * as S from "./styles";
import { useDispatcherCustomerDetail } from "./useDispatcherCustomerDetail";

export const DispatcherCustomerDetailTemplate = () => {
  const { navigate, dataClient, handleConfirm } = useDispatcherCustomerDetail();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Dados do Cliente</Title>

        <S.FormDataClient>
          <div>
            <Input value={dataClient?.nome} label="Nome" disabled />
          </div>
          <div>
            <Input value={dataClient?.cpfCnpj} label="CPF/ CNPJ" disabled />
          </div>
          <div>
            <Input value={dataClient?.telefone} label="Telefone" disabled />
          </div>
          <div>
            <Input value={dataClient?.email} label="E-mail" disabled />
          </div>
          <div>
            <Button
              type="button"
              data-variant-text
              onClick={() => navigate(-1)}
            >
              Voltar
            </Button>
            <Button type="button" onClick={handleConfirm}>
              Avançar
            </Button>
          </div>
        </S.FormDataClient>
      </S.Wrapper>
    </S.Container>
  );
};
